import { atom  } from "recoil";

export const summonerLeagueDataState = atom({
    key : "summonerLeagueDataState",
    default : []
})